import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

import Card from "@/globalComponents/atoms/Card"
import { cleanEmptyParams } from "@/utilities/etc"
import MCALLEN_THEME from "@/utilities/json/McAllenTheme"

import InflowAuthLogo from "./-components/InflowAuthLogo"

export const Route = createFileRoute("/auth")({
  validateSearch: (
    search: Record<string, unknown>
  ): {
    qrLookupID: string | undefined
    redirect: string | undefined
  } => {
    return cleanEmptyParams({
      qrLookupID: (search.qrLookupID as string) || "",
      redirect: (search.redirect as string) || "",
    })
  },
  beforeLoad: ({ context, search }) => {
    const qrLookupID = search.qrLookupID
    const redirectPath = search.redirect
    if (context.isAuthenticated) {
      if (redirectPath) {
        throw redirect({
          to: redirectPath,
        })
      } else if (qrLookupID) {
        throw redirect({
          to: "/qr/$qrLookupID",
          params: { qrLookupID },
        })
      } else {
        throw redirect({
          to: "/",
        })
      }
    }
    if (search.qrLookupID) {
      context.setScannedArea({
        qrLookupID: search.qrLookupID,
        theme: MCALLEN_THEME,
      })
      context.setDocumentThemeMode("whiteLabel")
    } else {
      context.setDocumentThemeMode("root")
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Card>
      <InflowAuthLogo />
      <Outlet />
    </Card>
  )
}
